<template>
  <div class="navbar_wrap hidden-xs-only" :style="{ backgroundColor: navBackground }">
    <div class="navbar_container">
      <div class="navbar_left">
        <img src="@/assets/img/carbon/hongly-logo2.png" alt="弘绿元..." @click="goHome" />
      </div>
      <div class="navbar_right">
        <el-menu
          :default-active="activeIndex"
          class="el_menu_demo"
          mode="horizontal"
          :background-color="navBackground"
          :text-color="navFontColor"
          :active-text-color="navFontColor"
          @select="changeCurrentPage"
        >
          <el-submenu index="2">
            <template slot="title">
              <span class="menu_item">{{ $t('nav.aboutus') }}</span>
            </template>
            <el-menu-item index="2-1" class="menu_item">{{ $t('nav.aboutusInfo') }}</el-menu-item>
            <el-menu-item index="2-2" class="menu_item">{{ $t('nav.newsCenter') }}</el-menu-item>
            <el-menu-item index="2-3" class="menu_item">{{ $t('nav.joinus') }}</el-menu-item>
            <el-menu-item index="2-4" class="menu_item">{{ $t('nav.consultnow') }}</el-menu-item>
          </el-submenu>
          <el-menu-item index="3" class="menu_item">{{ $t('nav.ssccp') }}</el-menu-item>
          <el-menu-item index="4" class="menu_item">{{ $t('nav.toolCloud') }}</el-menu-item>
          <el-menu-item index="5" class="menu_item">{{ $t('nav.onlineTraining') }}</el-menu-item>
          <!-- <el-submenu index="5">
            <template slot="title">
              <span class="menu_item">{{ $t('nav.onlineTraining') }}</span>
            </template>
            <el-menu-item index="5-1" class="menu_item">{{ $t('nav.ociit') }}</el-menu-item>
            <el-menu-item index="5-2" class="menu_item">{{ $t('nav.pcft') }}</el-menu-item>
            <el-menu-item index="5-3" class="menu_item">{{ $t('nav.ESGmtapt') }}</el-menu-item>
            <el-menu-item index="5-4" class="menu_item">{{ $t('nav.eat') }}</el-menu-item>
            <el-menu-item index="5-5" class="menu_item">{{ $t('nav.emsiat') }}</el-menu-item>
            <el-menu-item index="5-6" class="menu_item">{{ $t('nav.iatfems') }}</el-menu-item>
            <el-menu-item index="5-7" class="menu_item">{{ $t('nav.ISCC') }}</el-menu-item>
            <el-menu-item index="5-8" class="menu_item">{{ $t('nav.ecovadisTraining') }}</el-menu-item>
            <el-menu-item index="5-9" class="menu_item">{{ $t('nav.cbamTraining') }}</el-menu-item>
            <el-menu-item index="5-10" class="menu_item">{{ $t('nav.euBatteryTraining') }}</el-menu-item>
            <el-menu-item index="5-11" class="menu_item">{{ $t('nav.ctc') }}</el-menu-item>
          </el-submenu> -->
        </el-menu>
        <span class="right_phone">
          <!-- <a class="login" @click="">{{ $t('auth.login') }}</a> -->
          <!-- <a class="register">{{ $t('auth.register') }}</a> -->
          <router-link class="register" to="/trial">{{ $t('nav.startTrial') }}</router-link>
          <a class="lang-switch" @click="switchLanguage">
            {{ currentLang === 'zh' ? 'EN' : '中文' }}
          </a>
        </span>
        <!-- <router-link to="/shopping" style="color: #f29c11;">
          <i class="el-icon-shopping-cart-1"></i>
        </router-link> -->
        <!-- <router-link class="loginRedc" to="#" @click.native.prevent="toRedc">{{ $t('nav.redcPlus.login') }}</router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '1',
      navBackground:'#fff',
      navFontColor: '#000',
      currentLang: localStorage.getItem('language') || 'zh'
    }
  },
  props: {
    selectIndex: {
      type: String,
      default: '0',
    },
  },
  mounted() {
    this.activeIndex = this.selectIndex
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.navBackground = scrollTop > 0 ? '#fff' : '#fff';
    },
    goHome() {
      this.$router.push('/home');
    },
    toRedc() {
      window.open('https://redc.carbon-tc.com/', '_blank')
    },
    changeCurrentPage(index) {
      this.activeIndex = index
      switch (this.activeIndex) {
        case '2-1':
          this.$router.push('/aboutUs').catch((v) => {})
          break
        case '2-2':
          this.$router.push('/newsCenter').catch((v) => {})
          break
        case '2-3':
          this.$router.push('/joinUs').catch((v) => {})
          break
        case '2-4':
          this.$router.push('/trial').catch((v) => {})
          break
        case '2-5':
        this.$router.push('/production/ecoVadis').catch((v) => {})
          break
        case '2-6':
          this.$router.push('/').catch((v) => {})
          break
        case '2-7':
          this.$router.push('/').catch((v) => {})
          break
        case '2-8':
          this.$router.push('/').catch((v) => {})
          break
        case '2-9':
          this.$router.push('/').catch((v) => {})
          break
        case '2-10':
          this.$router.push('/').catch((v) => {})
          break
        case '2-11':  
          this.$router.push('/').catch((v) => {})
          break
        case '2-13':
          this.$router.push('/production/redcPlus').catch((v) => {})
          break
        case '2-14':
          this.$router.push('/production/lca').catch((v) => {})
          break
        case '2-15':
        this.$router.push('/production/ccer').catch((v) => {})
          break
        case '2-16':
          this.$router.push('/').catch((v) => {})
          break
        case '3':
          this.$router.push('/SustainableSupplyChainCloud').catch((v) => {})
          break
        case '4':
          this.$router.push('/toolCloud').catch((v) => {})
          break
        case '5':
          this.$router.push('/training').catch((v) => {})
          break
        case '6':
          this.$router.push('/aiSearch').catch((v) => {})
          break
        case '7':
          this.$router.push('/newsCenter').catch((v) => {})
          break
        default:
          break
      }
    },
    switchLanguage() {
      const newLang = this.currentLang === 'zh' ? 'en' : 'zh';
      this.currentLang = newLang;
      this.$i18n.locale = newLang;
      localStorage.setItem('language', newLang);
      document.documentElement.lang = newLang;
    },
  },
}
</script>

<style lang="scss" scoped>
.navbar_wrap {
  width: 100%;
  height: 70px;
  background-color: v-bind(navBackground);
  box-shadow: none;
  backdrop-filter: none; 
  // backdrop-filter: saturate(180%) blur(0.5rem);
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  .navbar_container {
    position: relative;
    width: 70%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .navbar_left {
      display: flex;
      align-items: center;
      height: 100%;
      img {
        width: 60px;
        cursor: pointer;
      }
    }
    .navbar_right {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      // justify-content: flex-end;
      padding-left: 1%;
      font-size: 20px;
      a {
        text-decoration: none;
        color: #0038a4;
        display: inline-block;
        width: 100px;
        line-height: 27px;
        text-align: center;
        padding: 5px;
      }
      .el_menu_demo {
        border: none;
      }
      .menu_item {
        font-size: 26px;
        color: #000;
      }
      .right_phone {
        position: absolute;            // 固定在 navbar 右上角
        top: 20px;                     // 距顶部距离（根据 navbar 高度微调）
        right: 40px;                   // 距右侧固定距离
        display: flex;
        align-items: center;
        gap: 12px;                     // 手机号与语言切换按钮之间的间距
        color: orange;
        font-size: 18px;

        i {
          font-size: 20px;
        }

        .login {
          border: 1px solid #F29C11;
          color: #F29C11;
          padding: 4px 10px;
          border-radius: 4px;
          &:hover {
            color: #0038a4;
          }
        }

        .register {
          margin-left: 10px;
          border: 1px solid #F29C11;
          background-color: #F29C11;
          color: white;
          padding: 4px 10px;
          border-radius: 4px;
        }

        .lang-switch {
          width: 50px;
          height: 38px;
          display: flex;
          justify-content: center;     // 水平居中
          align-items: center;         // 垂直居中
          border: 1px solid #F29C11;
          background-color: white;
          color: #F29C11;
          cursor: pointer;
          border-radius: 4px;
          margin-left: 10px;
          &:hover {
            color: #0038a4;
          }
        }
      }

      .loginRedc {
          border: 1px solid #F29C11;
          background-color: #F29C11;
          padding: 5px 10px;
          font-size: 14px;
          color: #fff;
          width: auto;
        }
    }
  }
}
</style>
<style lang="scss">
.el-menu--popup {
  background-color: white !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}
</style>